import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SearchOptions = ({
    favorited,
    setFavorited,
    starred,
    setStarred,
    setFilterMine,
    filterMine}) => { 
    return (
        <div className="search-options">
          <div
            onClick={() => setFilterMine(true)}
            className={filterMine ? "selected search-option": "search-option"}>
            My Projects
          </div>
          <div
            onClick={() => setFilterMine(false)}
            className={!filterMine ? "selected search-option": "search-option"}>
            All Projects
          </div>
          <div
            className={!favorited ? "heart" : "heart favorited"}
            onClick={() => setFavorited(!favorited)}>
          </div>
          <div
            className={!starred ? "star" : "star starred"}
            onClick={() => setStarred(!starred)}>
            <span>&#9734;</span>
          </div>
        </div>
    );
}



const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchOptions);
